<div class="flex flex-col gap-6">
  <div *ngFor="let item of questions; let i = index" class="p-4 border rounded-lg shadow-sm bg-white dark:bg-slate-800 dark:border-slate-700">
    <div class="flex items-start gap-4">
      <div class="mt-1">
        <p-checkbox
          [binary]="true"
          [(ngModel)]="item.selected"
          (onChange)="onCheckboxChange(i, $event)">
        </p-checkbox>
      </div>

      <div class="flex-1 flex flex-col gap-4">
        <!-- Question Text -->
        <div class="flex flex-col gap-1">
          <span class="text-xs font-semibold text-slate-500 uppercase tracking-wider">{{ 'clarification.form.question' | translate }} #{{ i + 1 }}</span>
          <div class="text-slate-700 dark:text-slate-300 font-medium" [innerHTML]="item.question.question"></div>
          <div class="text-xs text-slate-400 mt-1" *ngIf="item.question.raisonSociale">
            {{ 'clarification.table.assignee_name' | translate }}: {{ item.question.raisonSociale }}
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
          <!-- Answer Input -->
          <div class="md:col-span-3 flex flex-col gap-2">
            <label class="text-sm font-medium text-slate-600 dark:text-slate-400">{{ 'clarification.form.your_answer' | translate }}</label>
            <textarea
              pTextarea
              [autoResize]="true"
              rows="3"
              class="w-full"
              [(ngModel)]="item.answer"
              (input)="onAnswerInput(i, $event)"
              [placeholder]="'clarification.form.answer_placeholder' | translate">
            </textarea>
          </div>

          <!-- Type Selection -->
          <div class="flex flex-col gap-2">
            <label class="text-sm font-medium text-slate-600 dark:text-slate-400">{{ 'clarification.form.type_demande' | translate }}</label>
            <div class="flex flex-col gap-3 p-2 border rounded-md dark:border-slate-700">
              <div class="flex items-center">
                <p-radiobutton
                  name="typeQuestion_{{i}}"
                  value="SIMPLE"
                  [(ngModel)]="item.typeDemande"
                  (onClick)="onTypeChangeInternal(i, 'SIMPLE')"
                  id="simple_{{i}}">
                </p-radiobutton>
                <label for="simple_{{i}}" class="ml-2 text-sm cursor-pointer">SIMPLE</label>
              </div>
              <div class="flex items-center">
                <p-radiobutton
                  name="typeQuestion_{{i}}"
                  value="ADDITIF"
                  [(ngModel)]="item.typeDemande"
                  (onClick)="onTypeChangeInternal(i, 'ADDITIF')"
                  id="additive_{{i}}">
                </p-radiobutton>
                <label for="additive_{{i}}" class="ml-2 text-sm cursor-pointer">ADDITIF</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="questions.length === 0" class="text-center p-8 border-2 border-dashed rounded-lg text-slate-400">
    {{ 'clarification.no_questions' | translate }}
  </div>
</div>
